// extracted by mini-css-extract-plugin
module.exports = {"editButton":"more3-dot-dropdown_editButton__2Ye1t","deleteButton":"more3-dot-dropdown_deleteButton__Kg-jB"};